export default __webpack_public_path__ + "static/media/3x3_blue.ceea00f9.png";